export default __webpack_public_path__ + "static/media/client-logo-3.c21ec1e7.png";